import * as React from "react";
import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { HoverForHelp } from "components/common";
import useSearchConfiguration from "hooks/useSearchConfiguration";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import useMinimumRefreshInterval from "views/hooks/useMinimumRefreshInterval";
import RefreshControls from "components/common/RefreshControls";
import useDefaultInterval from "views/hooks/useDefaultIntervalForRefresh";
import useAutoRefresh from "views/hooks/useAutoRefresh";
import useTableFilterContext from "../../common/PaginatedEntityTable/useTableFilterContext";
const useDisableRefreshWhileSlicing = () => {
  const { searchParams } = useTableFilterContext();
  const { refreshConfig, stopAutoRefresh } = useAutoRefresh();
  const isSlicingEnabled = Boolean(searchParams.sliceCol);
  useEffect(() => {
    if (isSlicingEnabled && (refreshConfig == null ? void 0 : refreshConfig.enabled)) {
      stopAutoRefresh();
    }
  }, [isSlicingEnabled, refreshConfig == null ? void 0 : refreshConfig.enabled, stopAutoRefresh]);
  return isSlicingEnabled;
};
const EventsRefreshControls = () => {
  const { t } = useTranslation("events");
  const sendTelemetry = useSendTelemetry("alerts-page");
  const { config } = useSearchConfiguration();
  const autoRefreshTimerangeOptions = config == null ? void 0 : config.auto_refresh_timerange_options;
  const { data: minimumRefreshInterval, isInitialLoading: isLoadingMinimumInterval } = useMinimumRefreshInterval();
  const isSlicingEnabled = useDisableRefreshWhileSlicing();
  const onSelectInterval = useCallback(
    (interval) => {
      sendTelemetry(TELEMETRY_EVENT_TYPE.ALERTS_REFRESH_CONTROL_PRESET_SELECTED, {
        app_action_value: "refresh-alerts-control-dropdown",
        event_details: { interval }
      });
    },
    [sendTelemetry]
  );
  const onToggle = useCallback(
    (enabled) => {
      sendTelemetry(TELEMETRY_EVENT_TYPE.ALERTS_REFRESH_CONTROL_TOGGLED, {
        app_pathname: "alerts",
        app_action_value: "refresh-alerts-control-enable",
        event_details: { enabled }
      });
    },
    [sendTelemetry]
  );
  const defaultInterval = useDefaultInterval();
  if (!config) {
    return null;
  }
  const intervalOptions = autoRefreshTimerangeOptions ? Object.entries(autoRefreshTimerangeOptions) : [];
  return /* @__PURE__ */ React.createElement(
    RefreshControls,
    {
      disable: isSlicingEnabled,
      intervalOptions,
      isLoadingMinimumInterval,
      minimumRefreshInterval,
      defaultInterval,
      humanName: t("alerts_list.refresh_human_name"),
      onToggle,
      onSelectInterval
    },
    isSlicingEnabled && /* @__PURE__ */ React.createElement(
      HoverForHelp,
      {
        title: t("alerts_list.auto_refresh_unavailable_title"),
        placement: "left",
        pullRight: false,
        iconSize: "sm"
      },
      t("alerts_list.auto_refresh_unavailable")
    )
  );
};
export default EventsRefreshControls;
